import React from 'react'
import { PageTitle } from 'src/components/PageLayout/PageTitle'
import {
  IndexPageContainer,
  IndexPageContent,
  IndexPageHeader,
  IndexPageTabsContainer,
} from '../../PageLayout/PageLayout.styles'
import { GridContainer } from '../Grid'

type IndexPageProps = {
  title: string
  filterBar?: JSX.Element
  actions?: JSX.Element
  message?: JSX.Element
  indexGrid?: JSX.Element
  tabs?: JSX.Element
  pagination?: JSX.Element
  modals?: JSX.Element[]
  noTitleBorder?: boolean
}

export const IndexPage = ({
  title,
  actions,
  filterBar,
  message,
  indexGrid,
  tabs,
  pagination,
  modals,
  noTitleBorder,
}: IndexPageProps): JSX.Element => (
  <IndexPageContainer>
    <IndexPageHeader>
      <PageTitle title={title} noBorder={noTitleBorder} />
      {actions}
      {message}
      {filterBar}
    </IndexPageHeader>
    <IndexPageContent>
      {tabs && <IndexPageTabsContainer>{tabs}</IndexPageTabsContainer>}
      <GridContainer>{indexGrid}</GridContainer>
      {pagination}
    </IndexPageContent>
    {modals?.map((modal) => modal)}
  </IndexPageContainer>
)
